import { put } from 'redux-saga/effects';
import { uploadFormConfigSuccessAction } from '../actions';
import { uploadFormConfigRequestApi } from 'common/api/website';
import { errorHandleAction } from 'components/error-handle/actions';

export function* uploadFormConfigRequestEffect() {
  try {
    const configObj = yield uploadFormConfigRequestApi();
    yield put(uploadFormConfigSuccessAction(configObj));
  } catch (error) {
    yield put(errorHandleAction(error, error.status));
  }
}
